const edgeUrl = import.meta.env.VITE_EDGE_API_URL;

export const Config = {
  edgeUrl,
};
